"use strict";

import angular from "angular";

import _ from "lodash";

angular.module("nucont.accounting.company.parameterizationOnDemand").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting.company.parameterizationOnDemand", {
        // `?dashboards` guarda a seleção do filtro de dashboards para ela sobreviver ao refresh.
        // Dinâmico porque trocar de dashboard é trocar de filtro, não de tela.
        url: "/parametrizacao-por-demanda/:date?dashboards",
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-accounting-company-parameterization-on-demand" */ "./parameterization-on-demand.entry"
            ).then(() =>
                $ocLazyLoad.inject("nucont.accounting.company.parameterizationOnDemand")
            );
        },
        params: {
            date: { value: null, dynamic: true },
            dashboards: { value: null, dynamic: true, squash: true },
            openParameterize: { value: null },
            withoutParameterizationOnDemand: { value: null }
        },
        views: {
            "admin@nucont.accounting": {
                component: "parameterizationOnDemandComponent",
                bindings: { companyData: "CompanyData" }
            }
        },
        data: {
            layoutConfig: {
                model: "LayoutConfigModel5",
                ignore: { object: "headerConfig", path: "title" },
                setAttrs: [
                    {
                        object: "headerConfig",
                        path: "moduleTitle.text",
                        value: "Parametrização"
                    },
                    {
                        object: "headerConfig",
                        path: "moduleTitle.enabled",
                        value: true
                    }
                ]
            }
        },
        bodyClass: "parameterization-module"
    });
}
